module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/标签-长图.eb2e7.png";